import { Component } from "react";
import axios from "axios";

import Loader from "../Loader/Loader.jsx";

import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { TfiFaceSad } from "react-icons/tfi";

import {
  LoaderWrapper,
  EmptyState,
  List,
  Item,
  GifImage,
  Pagination,
  PageButton,
} from "./GifList.styled.js";

const API_KEY = "CM3yGWWdqYvOQGWEjU96jBmSjixE25Z5";

class GifList extends Component {
  state = {
    gifs: [],
    loading: false,
    page: 0,
  };

  componentDidMount() {
    this.fetchGifs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.keyword !== this.props.keyword) {
      this.setState({ page: 0, gifs: [] }, () => this.fetchGifs(0));
      return;
    }

    if (prevState.page !== this.state.page) {
      this.fetchGifs(this.state.page);
    }
  }

  fetchGifs = async (page = this.state.page) => {
    this.setState({ loading: true });

    try {
      const offset = page * 12;

      const response = await axios.get("https://api.giphy.com/v1/gifs/search", {
        params: {
          api_key: API_KEY,
          q: this.props.keyword,
          limit: 12,
          offset,
        },
      });

      this.setState({
        gifs: response.data.data,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
    }
  };

  nextPage = () => {
    this.setState((prev) => ({ page: prev.page + 1 }));
  };

  prevPage = () => {
    if (this.state.page === 0) return;
    this.setState((prev) => ({ page: prev.page - 1 }));
  };

  render() {
    const { loading, gifs } = this.state;

    const isEmpty = !loading && gifs.length === 0;

    return (
      <div>
        {loading ? (
          <LoaderWrapper>
            <Loader visible={loading} />
          </LoaderWrapper>
        ) : isEmpty ? (
          <EmptyState>
            <span>Nothing found!</span>
            <TfiFaceSad />
          </EmptyState>
        ) : (
          <List>
            {gifs.map((gif) => (
              <Item key={gif.id}>
                <GifImage
                  src={gif.images.fixed_height.url}
                  alt={gif.title || "gif"}
                />
              </Item>
            ))}
          </List>
        )}

        <Pagination>
          <PageButton onClick={this.prevPage}>
            <FaArrowLeftLong />
          </PageButton>
          <PageButton onClick={this.nextPage}>
            <FaArrowRightLong />
          </PageButton>
        </Pagination>
      </div>
    );
  }
}

export default GifList;
